var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIcBalanceCardMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "8uqs2s4lqa",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1oegkjjpmb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1t153qk2oc",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -160) translate(-1) translate(25 115) translate(0 45) translate(0 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#8uqs2s4lqa)",
    d: "M4.167 0h11.666C18.135 0 20 1.865 20 4.167v6.666C20 13.135 18.135 15 15.833 15H4.167C1.865 15 0 13.135 0 10.833V4.167C0 1.865 1.865 0 4.167 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 2.5,
    x: 4.167,
    y: 9.167,
    fill: "url(#1oegkjjpmb)",
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.667,
    height: 1.667,
    x: 1.667,
    y: 4.167,
    fill: "url(#1t153qk2oc)",
    rx: 0.833
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcBalanceCardMenu);
export default __webpack_public_path__ + "static/media/icon-ic-balance-card-menu.56c0e41e.svg";
export { ForwardRef as ReactComponent };